import { useContext } from "react";
import { Context } from "core/store";

const useStore = () => {
    const [state, dispatch] = useContext(Context);
    const { repositoryFactory } = state;

    const authRepository = repositoryFactory.get("auth");
    const businessRepository = repositoryFactory.get("business");
    const lookupRepository = repositoryFactory.get("lookup");
    const addressRepository = repositoryFactory.get("address");
    const statRepository = repositoryFactory.get("stat");
    const membershipRepository = repositoryFactory.get("membership");
    const tRepository = repositoryFactory.get("tRepo");
    const settingsRepository = repositoryFactory.get("settingsRepo");
    const logoutRepository = repositoryFactory.get("logoutRepo");
    const diagnosticRepository = repositoryFactory.get("diagnosticRepo");
    const deliveryRepository = repositoryFactory.get("DeliveryAreas");
    const menuRepository = repositoryFactory.get("menu");
    const couponsRepository = repositoryFactory.get("coupons");
    const reportsRepository = repositoryFactory.get("reports");
    const priceListRepository = repositoryFactory.get("priceList");
    const mpServiceRepository = repositoryFactory.get("mpService");
    const languages = repositoryFactory.get("languages");

    return {
        state,
        dispatch,
        authRepository,
        businessRepository,
        lookupRepository,
        addressRepository,
        statRepository,
        membershipRepository,
        tRepository,
        settingsRepository,
        logoutRepository,
        diagnosticRepository,
        deliveryRepository,
        menuRepository,
        couponsRepository,
        reportsRepository,
        priceListRepository,
        mpServiceRepository,
        languages
    };
};

export default useStore;
